import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-profile-picture',
    templateUrl: './profile-picture.component.html',
    styleUrls: ['./profile-picture.component.css'],
    standalone: false
})
export class ProfilePictureComponent implements OnInit {
    @Input()
    public fileId: string;
    @Input()
    private name: string;

    @Input()
    private index?: number;
    @Input() profilePublicPage: boolean = false;

    public color: string;

    private colors: string[] = [
        'var(--app-warn)',
        'var(--app-accent)',
        'var(--app-accent)',
        'var(--app-primary)',
        'var(--app-primary)',
        'var(--app-primary)'
    ];
    public letter: string;
    constructor() {
        // if (!this.index) {
        //     this.color = this.chooseColor();
        // }
    }

    ngOnInit() {
        this.letter = this.name[0].toLocaleUpperCase();
        this.color = this.getColorByLetter(this.letter);
    }

    // Wählt eine zufällige Farbe (Index zwischen 1 und 6) für den Hintergrund des Autorbuchstabens aus.
    // chooseColor(): string {
    //     return this.colors[Math.floor(Math.random() * 6)];
    // }

    private letterColorMap: { [key: string]: number } = {
        'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5,
        'G': 0, 'H': 1, 'I': 2, 'J': 3, 'K': 4, 'L': 5,
        'M': 0, 'N': 1, 'O': 2, 'P': 3, 'Q': 4, 'R': 5,
        'S': 0, 'T': 1, 'U': 2, 'V': 3, 'W': 4, 'X': 5,
        'Y': 0, 'Z': 1
    };

    getColorByLetter(letter: string): string {
        const colorIndex = this.letterColorMap[letter] || 0;
        return this.colors[colorIndex];
    }

    // Holt das default Profilbild vom environment
    getDefaultProfileImageUrl(): string {
        return environment.defaultPictureProfile;
    }
}
